import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function OurStory() {
  return (
    <div
      id='our-story'
      className='flex flex-col lg:flex-row justify-center items-center bg-gradient-to-b from-[#242423] to-[#000000] text-white'
    >
      {/* Text Section */}
      <div className='w-full lg:w-1/2 flex flex-col p-6 md:p-10'>
        <label className='text-transparent bg-clip-text text-4xl md:text-5xl lg:text-6xl slavic-font bg-gradient-to-r from-yellow-400 to-yellow-800 mb-6'>
          НАША ПРИЧА
        </label>
        <p className='text-white text-lg md:text-xl lg:text-2xl p-4 md:p-6 slavic-font'>
          Ђенерал Пивара настала је 2021 године у част Ђенерал Драгољуба
          Михаиловића и свих бораца са слободу и част отаџбине. Одлучили смо да
          спојимо љубав према пиву и традицији нашег народа и тако створили
          производ који је много више од пива.
        </p>
        <p className='text-white text-lg md:text-xl lg:text-2xl p-4 md:p-6 slavic-font'>
          Свако наше пиво носи причу о људима који су, не мараће за сопствене
          животе, вођени највишим идеалима о слободи, правди и истини
          проживљавали судбине вредне дивљења и поштовања. Ово је наш допринос у
          борби да се историјска неправда нанета таквим људима исправи и да се
          њихова прича чује.
        </p>
        <p className='text-white text-lg md:text-xl lg:text-2xl p-4 md:p-6 slavic-font'>
          Од Чикада, Лондона, Буенос Аиреса, Аместрдама Сиднеја и многих других
          грагова широм света флашице наших пива поносно красе куће, локале,
          дворове и храмове. Наша борба тек је почела.
        </p>
      </div>

      {/* Carousel Section */}
      <div className='w-full lg:w-1/2 p-6 md:p-10'>
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          showArrows={true}
          showStatus={false}
        >
          <div>
            <img
              src='images/IMG_3381.jpg'
              alt='Image 1'
              className='h-full w-full object-cover'
            />
          </div>
          <div>
            <img
              src='images/IMG_3397_small.jpeg'
              alt='Image 2'
              className='h-full w-full object-cover'
            />
          </div>
        </Carousel>
      </div>
    </div>
  );
}
